import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-logo',
    template: `
        <div class="logo-container">
            <ng-container *ngIf="logoUrl; else defaultLogo">
                <img [src]="logoUrl" alt="Logo" class="tenant-logo" [height]="56" [width]="56" />
            </ng-container>

            <ng-template #defaultLogo>
                <svg width="50" height="50" viewBox="0 0 1254 1254" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="#000000" flood-opacity="0.10"/>
                        </filter>
                        <linearGradient id="textGray" x1="450" y1="640" x2="950" y2="850" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stop-color="#595959"/>
                        <stop offset="1" stop-color="#767676"/>
                        </linearGradient>
                    </defs>
                    <rect width="1254" height="1254" fill="#ffffff"/>
                    <circle cx="627" cy="627" r="571.82" fill="none" stroke="#005b8f" stroke-width="41.4" stroke-linecap="butt" stroke-linejoin="miter"/>
                    <path d="M627 55.2 A571.82 571.82 0 0 1 820.12 89.03" fill="none" stroke="#8b0048" stroke-width="41.4" stroke-linecap="butt" stroke-linejoin="miter"/>
                    <path d="M55.2 627 A571.82 571.82 0 0 1 84.02 441.41" fill="none" stroke="#8b0048" stroke-width="41.4" stroke-linecap="butt" stroke-linejoin="miter"/>
                    <path d="M396 322 C472 399 493 538 456 641 C421 739 350 777 295 766" fill="none" stroke="#005b8f" stroke-width="21" stroke-linecap="round" stroke-linejoin="round" filter="url(#softShadow)"/>
                    <circle cx="410" cy="450" r="31" fill="#8b0048" filter="url(#softShadow)"/>
                    <path d="M493 640 C399 674 340 762 366 889" fill="none" stroke="#666666" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" filter="url(#softShadow)"/>
                    <circle cx="406" cy="805" r="22" fill="#ffffff" stroke="#777777" stroke-width="1.5"/>
                    <circle cx="600" cy="622" r="10" fill="#676767" filter="url(#softShadow)"/>
                    <text x="716" y="818" text-anchor="middle" font-family="Helvetica Neue, Arial, Helvetica, sans-serif" font-size="208" font-weight="300" letter-spacing="-8" fill="url(#textGray)" filter="url(#softShadow)">siom</text>
                    <text x="781" y="891" text-anchor="middle" font-family="Helvetica Neue, Arial, Helvetica, sans-serif" font-size="54" font-weight="300" letter-spacing="-1" fill="#6f6f6f">the art of marble</text>
                </svg>
            </ng-template>
        </div>
    `,
    imports: [NgIf],
    styles: [
        `
            .logo-container {
                width: 56px;
                height: 56px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            :host {
                display: inline-block;
            }

            .tenant-logo {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
        `
    ]
})
export class Logo {
    @Input() logoUrl: string | null | undefined;
}
